module.exports = new __parcel__URL__("bomb.e2ff4896.wav").toString();